module.exports = __webpack_public_path__ + "img/22_maska_kvadrat-skruglenny.1c09886.svg";